import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

const savedLanguage = typeof window !== 'undefined' ? localStorage.getItem('appLanguage') : 'fr';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: savedLanguage,
    fallbackLng: 'fr',
    ns: ['navbar', 'home', 'settings', 'joboffers', 'toast'],
    defaultNS: 'navbar',
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    }
  });

export default i18n;